import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector, toObservable, nextToPromise, createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";

import { ZonaExtendidaForm } from "./form";
const ZonaExtendidaFormRx = componentToRx(ZonaExtendidaForm);
type Entity = models.ZonaExtendida;
const resource = resources.ZonaExtendida;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value?: Entity;
}
class ZonaExtendidaEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { };
    }
    idStr = (props: Props, state: State) => this.props.match.params.id;
    id = createSelector(this.idStr , id => id =="new" ? "new" : Number.parseInt(id) );
    esNuevo = createSelectorRx(this.id, id => id == "new");
    nuevoValue = (props: Props, state: State) => ({} as Entity);
    
    valueFromResource = createSelector(this.id, id => id == "new" ? toObservable({} as Entity) : observeResource(resource.get, id));
    valueFromState = (props: Props, state: State) => state.value;
    value = createSelector(this.valueFromState, this.valueFromResource, this.esNuevo, this.nuevoValue , (state, resource, esNuevo, nuevo) => state ? rx.Observable.from([state]) : esNuevo ? rx.Observable.from([nuevo]) : resource);

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id(this.props, this.state);
        const func = id == "new" ? resource.add : resource.update;
        const value = await nextToPromise(this.value(this.props, this.state));
        await func(value);
        history.go("../");
    }

    render() {
        const value = this.value(this.props, this.state);
        const id = this.id(this.props, this.state);
        return <ZonaExtendidaFormRx
            value={value}
            onChange={this.onChange}
            nuevo={id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const ZonaExtendidaEdit = withRouter(ZonaExtendidaEditComp);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/zonaextendida/edit/edit.tsx